import { render, staticRenderFns } from "./TagSelectorITSystems.vue?vue&type=template&id=c30508a2&scoped=true&"
import script from "./TagSelectorITSystems.vue?vue&type=script&lang=ts&"
export * from "./TagSelectorITSystems.vue?vue&type=script&lang=ts&"
import style0 from "./TagSelectorITSystems.vue?vue&type=style&index=0&id=c30508a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30508a2",
  null
  
)

export default component.exports